import {NgModule} from '@angular/core';
import {AssetService} from './asset.service';
import {BackofficeAssetService} from './backoffice-asset.service';
import {DisplayAssetFactory} from './display-asset.factory';

@NgModule({
    providers: [
        AssetService,
        BackofficeAssetService,
        DisplayAssetFactory
    ]
})
export class AssetModule {}
